export const enableFilterMenu = (filterMenu, index) => {
  return filterMenu.map((menu, menuIndex) =>
    menuIndex === index
      ? { ...menu, isActive: true }
      : { ...menu, isActive: false }
  );
};
